import { User } from '../../types';
import api from '../../api';
import recognition from '../../auth/recognition';

export default function invite(
  accountId: string, firstName: string, lastName: string,
  email: string, roleType: string|null,
): Promise<User> {
  return api
    .post('user-invitations', {
      senderId: recognition.getUserId(),
      accountId,
      firstName,
      lastName,
      email,
      roleType,
    })
    .then(response => response.data.recipient);
}

export function reinvite(userId: string): Promise<void> {
  return api.put(`users/${userId}/reinvite`).then();
}

export function acceptInvite(token: string, password: string): Promise<User> {
  return api
    .put(`user-invitations/${token}/accept`, { password })
    .then(response => response.data);
}
